/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
// import "../Dashboard/Dashboard.css";

const ChartPage = ({ OrderGraphData }) => {
  const chartRef = useRef();

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    const chartData = {
      labels: OrderGraphData.map((item) => item.month),
      datasets: [
        {
          label: "Orders Data",
          data: OrderGraphData.map((item) => item.user),
          borderColor: "blue",
          backgroundColor: "blue",
          // backgroundColor: "#4B49AC",
          fill: false, // Set to false for a line chart
        },
      ],
    };

    new Chart(ctx, {
      type: "line", // Use 'line' for a line chart
      data: chartData,
      options: {
        scales: {
          x: {
            type: "category", // If your x-axis labels are category labels (e.g., month names)
            position: "bottom", // Position of the x-axis
          },
          y: {
            beginAtZero: true, // Start the y-axis at zero
          },
        },
        plugins: {
          legend: {
            display: true, // Display the legend
            position: "top", // Position of the legend (e.g., 'top', 'bottom', 'right', 'left')
          },
        },
        responsive: true, // Make the chart responsive
        maintainAspectRatio: false, // Prevent maintaining aspect ratio
        interaction: {
          mode: "index", // Set interaction mode (e.g., 'index', 'nearest')
        },
      },
    });
  }, []);

  return (
    <div>
      <canvas
        ref={chartRef}
        width={501}
        height={250}
        style={{ display: "block", width: 501, height: 250 }}
        className="chartjs-render-monitor"
        id="line-chart"
      />
    </div>
  );
};

// export default ChartPage;

const BarChart = ({ UserGraphData }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current && UserGraphData) {
      const SalesChartCanvas = chartRef.current?.getContext("2d");

      new Chart(SalesChartCanvas, {
        type: "bar",
        data: {
          labels: UserGraphData.map((item) => item.month),
          datasets: [
            {
              label: "Users Data",
              data: UserGraphData.map((item) => item.user),
              backgroundColor: "blue",
              // backgroundColor: "#1f4ce0",
              // backgroundColor: "#4B49AC",
            },
          ],
        },
        options: {
          scales: {
            x: {
              type: "category", // If your x-axis labels are category labels (e.g., month names)
              position: "bottom", // Position of the x-axis
            },
            y: {
              beginAtZero: true, // Start the y-axis at zero
              // ticks: {
              //   stepSize: 100, // Define the step size between ticks
              // },
            },
          },
          plugins: {
            legend: {
              display: true, // Display the legend
              position: "top", // Position of the legend (e.g., 'top', 'bottom', 'right', 'left')
            },
          },
          responsive: true, // Make the chart responsive
          maintainAspectRatio: false, // Prevent maintaining aspect ratio
          interaction: {
            mode: "index", // Set interaction mode (e.g., 'index', 'nearest')
          },
        },
      });

      // If you want to generate a legend, you can do it here
      // You may need to manage the legend yourself in React
      // document.getElementById('sales-legend').innerHTML = SalesChart.generateLegend();
    }
  }, []);

  return (
    <div>
      <canvas
        ref={chartRef}
        width={501}
        height={250}
        className="chartjs-render-monitor"
        style={{ display: "block", width: 501, height: 250 }}
      />
    </div>
  );
};

export { ChartPage, BarChart };
